
import {Component, Vue} from 'vue-property-decorator';
import config from '@/config';

@Component({})
export default class RecaptchaMixin extends Vue {
  showRecaptcha: boolean = false;
  recaptchaSiteKey: string = config.recaptchaKey;
  recaptchaResponse: string = '';

  onRecaptchaVerify(response:string) {
    this.recaptchaResponse = response;
  }

  onRecaptchaExpired() {
    this.recaptchaResponse = '';
  }
}
